import { FC, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import './index.scss';

interface propsType {
  datas: any; //数据源
  reload?: () => void; //倒计时结束 刷新页面
}
const SignInCountDown: FC<propsType> = (props) => {
  const { datas, reload } = props;
  const [countType, setCountType] = useState<number>(0); // 提醒类型  1大于5天 2小于5天  3小于1天
  const [hour, setHour] = useState<any>('00'); //时
  const [minute, setMinute] = useState<any>('00'); //分
  const [second, setSecond] = useState<any>('00'); //秒
  const [timer, setTimer] = useState<any>();
  /**
   * @description: 计算时间
   */
  const calcTime = (totalTime: number) => {
    //         const day = Math.floor((sys_second / 1000 / 3600) / 24);
    //         const hour = Math.floor((sys_second / 1000 / 3600) % 24);
    const hour = Math.floor(totalTime / 1000 / 3600);
    const minute = Math.floor((totalTime / 1000 / 60) % 60);
    const second = Math.floor((totalTime / 1000) % 60);
    setHour(hour < 10 ? '0' + hour : hour);
    setMinute(minute < 10 ? '0' + minute : minute);
    setSecond(second < 10 ? '0' + second : second);
  };
  //倒计时
  const countDowm = (totalTime: number) => {
    if (totalTime >= 0) {
      setTimer(
        setTimeout(async () => {
          const _totalTime = totalTime - 1000;
          calcTime(_totalTime);
          clearTimeout(timer);
          countDowm(_totalTime);
        }, 1000),
      );
    } else {
      //恢复初始化00
      setHour('00');
      setMinute('00');
      setSecond('00');
      reload && reload();
    }
  };
  useEffect(() => {
    if (!datas) {
      return;
    }
    let { today, expireDate } = datas;
    today = today && today.replace(/-/g, '/');
    expireDate = expireDate && expireDate.replace(/-/g, '/');
    const dayTotal = dayjs(expireDate).diff(dayjs(today), 'day'); //计算开始结束差值天数

    // setCountType  1大于5天 2小于5天  3小于1天
    if (dayTotal >= 5) {
      setCountType(1);
    } else if (dayTotal < 5 && dayTotal >= 1) {
      setCountType(2);
    } else if (dayTotal < 1) {
      setCountType(3);
      const end_time = new Date(expireDate).getTime();
      const totalTime = end_time - new Date(today).getTime();
      clearTimeout(timer);
      calcTime(totalTime); //初始化执行一次 显示总时间
      countDowm(totalTime);
    }
  }, [datas]);
  return (
    <div className="signin-count-down">
      {countType !== 3 ? (
        <div className={`${countType === 1 ? 'long' : 'medium'}`}>
          本期碎片将于 {datas && datas.expireDate.split(' ')[0]} 到期
        </div>
      ) : (
        <div className="short">
          本期碎片将于
          <span className="short__block">{hour || '00'}</span>
          <span>:</span>
          <span className="short__block">{minute || '00'}</span>
          <span>:</span>
          <span className="short__block">{second || '00'}</span>
          后过期
        </div>
      )}
    </div>
  );
};

export default SignInCountDown;
